import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

import type * as GraphQLTypes from '../../../../graphql/types.generated';
const defaultOptions = {} as const;

export type CreateWebhookMutationVariables = GraphQLTypes.Exact<{
  input: GraphQLTypes.CreateWebhookInput;
}>;

export type CreateWebhookMutationResult = { __typename?: 'Mutation' } & {
  webhookSubscriptionsCreateWebhook?: GraphQLTypes.Maybe<
    { __typename?: 'CreateWebhookPayload' } & Pick<GraphQLTypes.CreateWebhookPayload, 'signToken'> & {
        errors?: GraphQLTypes.Maybe<Array<{ __typename?: 'Error' } & Pick<GraphQLTypes.Error, 'message' | 'path'>>>;
      }
  >;
};

export const CreateWebhookDocument = /*#__PURE__*/ gql`
  mutation createWebhook($input: CreateWebhookInput!) {
    webhookSubscriptionsCreateWebhook(input: $input) {
      errors {
        message
        path
      }
      signToken
    }
  }
`;

/**
 * __useCreateWebhookMutation__
 *
 * To run a mutation, you first call `useCreateWebhookMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWebhookMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWebhookMutation, { data, loading, error }] = useCreateWebhookMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateWebhookMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateWebhookMutationResult, CreateWebhookMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<CreateWebhookMutationResult, CreateWebhookMutationVariables>(CreateWebhookDocument, options);
}
export type CreateWebhookMutationHookResult = ReturnType<typeof useCreateWebhookMutation>;
